import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import todo from "../../Assets/Projects/todo.png";
import MERN from "../../Assets/Projects/MERN.png";
import Delivery from "../../Assets/Projects/Delivery.png";
import saledashboard from "../../Assets/Projects/saledashboard.png";
import Crypto from "../../Assets/Projects/Crypto.png";
import Portfolio from "../../Assets/Projects/Portfolio.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={saledashboard}
              isBlog={false}
              title="Sale Admin Dashboard"
              description="An Upwork project that clients requires me to do. Works done beforehand is UX/UI design on Figma & Sketch. After making final draft to client then, and then code them out. Collab with back-end developer in some tasks"
              ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://sale-dashboard-minh.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              isBlog={false}
              title="This-Wonderful-Portfolio"
              description="My personal portfolio page build with React, React-DOM and React-Router, with some advance concepts of CSS such as flex, box model, sass, ..."
              ghLink="/"
              demoLink="/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Delivery}
              isBlog={false}
              title="Pizza Delivery App"
              description="A Nice Looking pizza dilivery app that I built for a client on Upwork. This project costs them $.3000 and some bonus that they gave me when I finish before deadlines with nice results. Please click 'back to site' when error appear"
              ghLink="https://github.com/minh2407/pizza-deli"
              demoLink="https://minh-delivery.netlify.app/home"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="To Do App"
              description="A Quick & Easy Todo App with Redux Toolkit, Edit, Delete, Sort with motion advanced CSS styling and so on. "
              ghLink="https://github.com/minh2407/todo-1"
              demoLink="https://minh-todo-1.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Crypto}
              isBlog={false}
              title="Crypto Dashboard Project with Rapid API"
              description="Using Rapid API to fetch the chart data, news, relevant crypto content and so on. This project contains most of the hooks, also built with React-Router. "
              ghLink="https://github.com/minh2407/crypto-dash"
              demoLink="/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MERN}
              isBlog={false}
              title="Full Stack Social Media App (MERN stack)"
              description="A Full Stack application with CRUD Redux, React Hooks, custom Hooks. Database stored in MongoDB, server side we have Express JS, Node JS and also Axios to fetch API for fetching posts and users, authentication and like, comment function build with Redux and other interesting things"
              ghLink="https://github.com/minh2407/memory-keeper"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
